fragment AdminFragment on Admin {
    id
    name
    email
    locale
    permissions
    default_tenant {
        ...TenantFragment
    }
}